import { Injectable, TemplateRef, inject } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViewFilePopupComponent } from '../../../qualifications/view-file-popup/view-file-popup.component';
import { ConfirmationDialogueComponent } from '@wilson/shared-components';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * @deprecated This service should not be used instead use NzModalService
 */
@Injectable()
export class ModalService {
  private modalService = inject(NgbModal);

  public confirm(
    title: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    message: string | TemplateRef<any>,
    btnOkText = 'general.save',
    btnCancelText = 'general.cancel',
    dialogSize: 'sm' | 'lg' | 'md' = 'md',
    icon?: IconDefinition,
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogueComponent, {
      size: dialogSize,
      centered: true,
      backdrop: 'static',
    });
    const componentInstance: ConfirmationDialogueComponent =
      modalRef.componentInstance;
    componentInstance.title = title;
    if (typeof message === 'string') {
      componentInstance.message = message;
    } else {
      componentInstance.content = message;
    }
    componentInstance.btnOkText = btnOkText;
    componentInstance.btnCancelText = btnCancelText;
    if (icon) {
      componentInstance.faIcon = icon;
    }
    return modalRef.result;
  }

  public alert(
    title: string,
    message: string,
    btnOkText = 'general.ok',
    dialogSize: 'sm' | 'lg' | 'md' = 'md',
  ): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmationDialogueComponent, {
      size: dialogSize,
      centered: true,
      backdrop: 'static',
    });
    const componentInstance: ConfirmationDialogueComponent =
      modalRef.componentInstance;
    componentInstance.title = title;
    componentInstance.message = message;
    componentInstance.btnOkText = btnOkText;
    return modalRef.result;
  }

  public viewFile(file: string, name: string): Promise<boolean> {
    const modalRef = this.modalService.open(ViewFilePopupComponent, {
      size: name.search('.jpg') > 0 ? 'md' : 'lg',
      centered: true,
      backdrop: 'static',
    });
    const componentInstance: ViewFilePopupComponent =
      modalRef.componentInstance;
    componentInstance.file = file;
    componentInstance.name = name;
    return modalRef.result;
  }
}
